import React from "react";
import styles from "./custom-button.module.css";

export default function CustomButton({
  label,
  image,
  position = "left",
  handleClick,
  isDisabled = false,
  extraStyle = ""
}) {
  let style = "";
  if (extraStyle != "") {
    style = `${styles["container"]}  ${styles[extraStyle]} ${
    isDisabled ? styles["disable"] : ""}`;

  } else {
    style = `${styles["container"]}  ${isDisabled ? styles["disable"] : ""}`;
  }

  return (
    <div
      className={style}
      onClick={() => {
        handleClick && !isDisabled && handleClick();
      }}>

      {image && position == "left" &&
      <img src={image} className={styles["button-img"]} />
      }
      <div className={styles["button-text"]}>{label}</div>
      {image && position == "right" &&
      <img src={image} className={styles["button-img"]} />
      }
    </div>);

}